import { FormatterFunc } from 'src/components/molecules/DataTable/cellFuncs';
import { TimeseriesDataTableModal as SharedTimeseriesDataTableModal } from 'src/components/organisms/TimeseriesDataTableModal';
import { useAggregationLevelContext } from 'src/features/MM/contexts/AggregationLevelContext';
import { useGetDateAxisFormatter } from 'src/features/MM/hooks/useGetDateAxisFormatter';
import { getAggregationName } from 'src/features/MM/utils/getAggregationName';

type DataRow = {
  utcEpoch: number;
} & Record<string, number | null>;

type TimeseriesDataTableModalProps = {
  setIsOpen: (isOpen: boolean) => void;
  isOpen: boolean;
  headerName: string;
  data: Array<DataRow>;
  yFormatter: FormatterFunc;
};

// MM variant: date column and CSV name follow the selected aggregation level
export const TimeseriesDataTableModal: React.FC<
  TimeseriesDataTableModalProps
> = ({ setIsOpen, isOpen, headerName, yFormatter, data }) => {
  const { aggregateLevel } = useAggregationLevelContext();
  const dateFormatter = useGetDateAxisFormatter();

  return (
    <SharedTimeseriesDataTableModal
      setIsOpen={setIsOpen}
      isOpen={isOpen}
      headerName={headerName}
      csvFileName={`${headerName} - ${getAggregationName(aggregateLevel)}`}
      data={data}
      yFormatter={yFormatter}
      dateFormatter={dateFormatter}
    />
  );
};
